import { LayerType } from '@/commons/enums/layer-type';
import { graphicStore } from '@/commons/store/graphic-store';
import { ReactComponent as DianSvg } from '@/commons/icons/new/dian.svg';
import { ReactComponent as XianSvg } from '@/commons/icons/new/xian.svg';
import { ReactComponent as DuoyixianSvg } from '@/commons/icons/new/duoyixian.svg';
import { ReactComponent as YuanSvg } from '@/commons/icons/new/yuan.svg';
import { ReactComponent as TuoyuanSvg } from '@/commons/icons/new/tuoyuan.svg';
import { ReactComponent as DuobianxingSvg } from '@/commons/icons/new/duobianxing.svg';
import { ReactComponent as HuSvg } from '@/commons/icons/new/hu.svg';
import { ReactComponent as JvxingSvg } from '@/commons/icons/new/jvxing.svg';
import { ReactComponent as MianyuSvg } from '@/commons/icons/new/mianyu.svg';
import { ReactComponent as LifangtiSvg } from '@/commons/icons/new/lifangti.svg';
import { ReactComponent as QiutiSvg } from '@/commons/icons/new/qiuti.svg';
import { ReactComponent as XuanzhuantiSvg } from '@/commons/icons/new/xuanzhuanti.svg';
import { ReactComponent as LashentiSvg } from '@/commons/icons/new/lashenti.svg';

import { ReactComponent as BuercaozuoSvg } from '@/commons/icons/menu/geometry/buercaozuo.svg';
import { ReactComponent as ChongheSvg } from '@/commons/icons/menu/geometry/chonghe.svg';
import { ReactComponent as ChuizhiSvg } from '@/commons/icons/menu/geometry/chuizhi.svg';
import { ReactComponent as DaduanSvg } from '@/commons/icons/menu/geometry/daduan.svg';
import { ReactComponent as DanhangwenziSvg } from '@/commons/icons/menu/geometry/danhangwenzi.svg';
import { ReactComponent as DaojiaoSvg } from '@/commons/icons/menu/geometry/daojiao.svg';
import { ReactComponent as DuichengSvg } from '@/commons/icons/menu/geometry/duicheng.svg';
import { ReactComponent as FenjieSvg } from '@/commons/icons/menu/geometry/fenjie.svg';
import { ReactComponent as GongxianSvg } from '@/commons/icons/menu/geometry/gongxian.svg';
import { ReactComponent as HebingSvg } from '@/commons/icons/menu/geometry/hebing.svg';

import { ReactComponent as LashengmianSvg } from '@/commons/icons/menu/geometry/lashengmian.svg';
import { ReactComponent as DuiqiSvg } from '@/commons/icons/menu/geometry/duiqi.svg';
import { ReactComponent as PianyiSvg } from '@/commons/icons/menu/geometry/pianyi.svg';
import { ReactComponent as PingxingSvg } from '@/commons/icons/menu/geometry/pingxing.svg';
import { ReactComponent as SanweifengeSvg } from '@/commons/icons/menu/geometry/sanweifenge.svg';
import { ReactComponent as SanweituilaSvg } from '@/commons/icons/menu/geometry/sanweituila.svg';
import { ReactComponent as SaoluetiSvg } from '@/commons/icons/menu/geometry/saolueti.svg';
import { ReactComponent as ShuipingSvg } from '@/commons/icons/menu/geometry/shuiping.svg';
import { ReactComponent as TietuSvg } from '@/commons/icons/menu/geometry/tietu.svg';
import { ReactComponent as ShuzhiSvg } from '@/commons/icons/menu/geometry/shuzhi.svg';

import { ReactComponent as YuanzhuitiSvg } from '@/commons/icons/menu/geometry/yuanzhuiti.svg';
import { ReactComponent as YuanhuantiSvg } from '@/commons/icons/menu/geometry/yuanhuanti.svg';
import { ReactComponent as YanshenSvg } from '@/commons/icons/menu/geometry/yanshen.svg';
import { ReactComponent as YangtiaoquxianSvg } from '@/commons/icons/menu/geometry/yangtiaoquxian.svg';
import { ReactComponent as XiujianSvg } from '@/commons/icons/menu/geometry/xiujian.svg';
import { ReactComponent as XiugaiyanseSvg } from '@/commons/icons/menu/geometry/xiugaiyanse.svg';
import { ReactComponent as XiugaixianxingSvg } from '@/commons/icons/menu/geometry/xiugaixianxing.svg';
import { ReactComponent as XiangqieSvg } from '@/commons/icons/menu/geometry/xiangqie.svg';
import { ReactComponent as XiangdengSvg } from '@/commons/icons/menu/geometry/xiangdeng.svg';
import { ReactComponent as TongxinSvg } from '@/commons/icons/menu/geometry/tongxin.svg';



export default function GeometryMenu() {

    const onActiveSubControl = (cmd: string) => {
        if (!graphicStore.extraContext.getCurrentViewEditor()) return;
        graphicStore.extraContext.getCurrentViewEditor()?.listeners.signals.onOpeCommandActive.dispatch(cmd);
    }

    const onActiveLine = () => {
        if (!graphicStore.extraContext.getCurrentViewEditor()) return;
        let cur = graphicStore.context.layerContext.layers?.find(item => item.uuid === graphicStore.context.layerContext.currentLayerUuid);
        if (cur?.type === LayerType.AXIS_NET) {
            graphicStore.extraContext.getCurrentViewEditor()?.listeners.signals.onOpeCommandActive.dispatch("BUILDGRIDLINE");
        } else {
            graphicStore.extraContext.getCurrentViewEditor()?.listeners.signals.onOpeCommandActive.dispatch("LINE");
        }
    }

    return (
        <div className='tn-menu-container'>
            <div className='ope-panel'>
                <div className='ope-col-area'>
                    <div className='ope-btn'>
                        <div className='ope-col'>
                            <div className='ope-item name3' onClick={() => { onActiveSubControl('POINT') }}>
                                <div className='icon'><DianSvg /></div>
                                <div className='name'>点</div>
                            </div>
                            <div className='ope-item name3' onClick={() => { onActiveLine() }}>
                                <div className='icon'><XianSvg /></div>
                                <div className='name'>直线</div>
                            </div>
                            <div className='ope-item name3' onClick={() => { onActiveSubControl('PLINE') }}>
                                <div className='icon'><DuoyixianSvg /></div>
                                <div className='name'>多义线</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item name3' onClick={() => { onActiveSubControl('CIRCLE') }}>
                                <div className='icon'><YuanSvg /></div>
                                <div className='name'>圆</div>
                            </div>
                            <div className='ope-item name3' onClick={() => { onActiveSubControl('ELLIPSE') }}>
                                <div className='icon'><TuoyuanSvg /></div>
                                <div className='name'>椭圆</div>
                            </div>
                            <div className='ope-item name3' onClick={() => { onActiveSubControl('POLYGON') }}>
                                <div className='icon'><DuobianxingSvg /></div>
                                <div className='name'>多边形</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item name2' onClick={() => { onActiveSubControl('ARC') }}>
                                <div className='icon'><HuSvg /></div>
                                <div className='name'>弧</div>
                            </div>
                            <div className='ope-item name2' onClick={() => { onActiveSubControl('RECTANG') }}>
                                <div className='icon'><JvxingSvg /></div>
                                <div className='name'>矩形</div>
                            </div>
                            <div className='ope-item name2' onClick={() => { onActiveSubControl('REGION') }}>
                                <div className='icon'><MianyuSvg /></div>
                                <div className='name'>面域</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item name3' onClick={() => { onActiveSubControl('BOX') }}>
                                <div className='icon'><LifangtiSvg /></div>
                                <div className='name'>长方体</div>
                            </div>
                            <div className='ope-item name3' onClick={() => { onActiveSubControl('SPHERE') }}>
                                <div className='icon'><QiutiSvg /></div>
                                <div className='name'>球体</div>
                            </div>
                            <div className='ope-item name3' onClick={() => { onActiveSubControl('REVOLVE') }}>
                                <div className='icon'><XuanzhuantiSvg /></div>
                                <div className='name'>旋转体</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item name3' onClick={() => { onActiveSubControl('EXTRUDE') }}>
                                <div className='icon'><LashentiSvg /></div>
                                <div className='name'>拉伸体</div>
                            </div>
                            <div className='ope-item name3 disabled' onClick={() => { }}>
                                <div className='icon'><SaoluetiSvg /></div>
                                <div className='name'>扫掠体</div>
                            </div>
                            <div className='ope-item name3 ' onClick={() => { onActiveSubControl('CONE') }}>
                                <div className='icon'><YuanzhuitiSvg /></div>
                                <div className='name'>圆锥体</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item ' onClick={() => { onActiveSubControl('TORUS') }}>
                                <div className='icon'><YuanhuantiSvg /></div>
                                <div className='name'>圆环体</div>
                            </div>
                            <div className='ope-item ' onClick={() => { onActiveSubControl('EXTRUDE') }}>
                                <div className='icon'><LashengmianSvg /></div>
                                <div className='name'>拉伸面</div>
                            </div>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><YangtiaoquxianSvg /></div>
                                <div className='name'>样条曲线</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item' onClick={() => { onActiveSubControl('DT') }}>
                                <div className='icon'><DanhangwenziSvg /></div>
                                <div className='name'>单行文字</div>
                            </div>
                            <div className='ope-item' onClick={() => { onActiveSubControl('REGT') }}>
                                <div className='icon'><MianyuSvg /></div>
                                <div className='name'>多点面域</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='ope-col-area'>
                    <div className='ope-btn'>
                        <div className='ope-col'>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><XiugaixianxingSvg /></div>
                                <div className='name'>修改线型</div>
                            </div>
                            <div className='ope-item disabled' onClick={() => { }}>
                                <div className='icon'><XiugaiyanseSvg /></div>
                                <div className='name'>修改颜色</div>
                            </div>
                            <div className='ope-item ' onClick={() => { onActiveSubControl('TRIM') }}>
                                <div className='icon'><XiujianSvg /></div>
                                <div className='name'>修剪</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item ' onClick={() => { onActiveSubControl('EXTEND') }}>
                                <div className='icon'><YanshenSvg /></div>
                                <div className='name'>延伸</div>
                            </div>
                            <div className='ope-item ' onClick={() => { onActiveSubControl('FILLET') }}>
                                <div className='icon'><DaojiaoSvg /></div>
                                <div className='name'>倒角</div>
                            </div>
                            <div className='ope-item ' onClick={() => { onActiveSubControl('INTERSECT') }}>
                                <div className='icon'><BuercaozuoSvg /></div>
                                <div className='name'>布尔操作</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item name2 ' onClick={() => { onActiveSubControl('BREAK') }}>
                                <div className='icon'><DaduanSvg /></div>
                                <div className='name'>打断</div>
                            </div>
                            <div className='ope-item name2 ' onClick={() => { onActiveSubControl('UNION') }}>
                                <div className='icon'><HebingSvg /></div>
                                <div className='name'>合并</div>
                            </div>
                            <div className='ope-item name2 ' onClick={() => { onActiveSubControl('OFFSET') }}>
                                <div className='icon'><PianyiSvg /></div>
                                <div className='name'>偏移</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item  disabled' onClick={() => { }}>
                                <div className='icon'><FenjieSvg /></div>
                                <div className='name'>分解</div>
                            </div>
                            <div className='ope-item  disabled' onClick={() => { }}>
                                <div className='icon'><SanweituilaSvg /></div>
                                <div className='name'>三维推拉</div>
                            </div>
                            <div className='ope-item  disabled' onClick={() => { }}>
                                <div className='icon'><SanweifengeSvg /></div>
                                <div className='name'>三维分割</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item name2 disabled' onClick={() => { }}>
                                <div className='icon'><TietuSvg /></div>
                                <div className='name'>贴图</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='ope-col-area'>
                    <div className='ope-btn'>
                        <div className='ope-col'>
                            <div className='ope-item name2 disabled ' onClick={() => { }}>
                                <div className='icon'><PingxingSvg /></div>
                                <div className='name'>平行</div>
                            </div>
                            <div className='ope-item name2 disabled ' onClick={() => { }}>
                                <div className='icon'><DuiqiSvg /></div>
                                <div className='name'>对齐</div>
                            </div>
                            <div className='ope-item name2 disabled ' onClick={() => { }}>
                                <div className='icon'><ChuizhiSvg /></div>
                                <div className='name'>垂直</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item name2 disabled ' onClick={() => { }}>
                                <div className='icon'><ShuipingSvg /></div>
                                <div className='name'>水平</div>
                            </div>
                            <div className='ope-item name2 disabled' onClick={() => { }}>
                                <div className='icon'><ShuzhiSvg /></div>
                                <div className='name'>竖直</div>
                            </div>
                            <div className='ope-item name2 disabled' onClick={() => { }}>
                                <div className='icon'><XiangqieSvg /></div>
                                <div className='name'>相切</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item name2 disabled ' onClick={() => { }}>
                                <div className='icon'><DuichengSvg /></div>
                                <div className='name'>对称</div>
                            </div>
                            <div className='ope-item name2 disabled ' onClick={() => { }}>
                                <div className='icon'><XiangdengSvg /></div>
                                <div className='name'>相等</div>
                            </div>
                            <div className='ope-item name2 disabled' onClick={() => { }}>
                                <div className='icon'><ChongheSvg /></div>
                                <div className='name'>重合</div>
                            </div>
                        </div>
                        <div className='ope-col'>
                            <div className='ope-item name2 disabled ' onClick={() => { }}>
                                <div className='icon'><GongxianSvg /></div>
                                <div className='name'>共线</div>
                            </div>
                            <div className='ope-item name2 disabled' onClick={() => { }}>
                                <div className='icon'><TongxinSvg /></div>
                                <div className='name'>同心</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}